import React from "react";
import { css } from "@emotion/react";
import { NumberInputSpinner } from "../NumberInputSpinner";
import {
  fontSize,
  fontWeight,
  lineHeight,
} from "main/javascripts/styles/base/typographyStyle";
import { space } from "main/javascripts/styles/base/spaceStyle";
import { useTranslation } from "react-i18next";
import {
  MAX_AGE_OF_CHILDREN,
  MAX_CHILDREN,
} from "../../../constants/CruiseConstants";
import { GuestChildrenAgeBlock } from "./GuestChildrenAgeBlock";
import { textColor } from "../../../styles/base/colorStyle";

interface IProps {
  namespace: string;
  groupName?: string;
  max?: number;
  onUpdate?(name: string, number: number): void;
}

export const GuestPickerInputChild: React.FC<IProps> = (
  props: IProps
): React.ReactElement<IProps> => {
  const { namespace, groupName, onUpdate, max } = props;
  const { t } = useTranslation(["constant", "label", "component"]);

  const fieldName = groupName
    ? `${groupName}.number_of_children`
    : "number_of_children";

  return (
    <div>
      <div css={[listInnerStyle, childSubListInnerStyle]}>
        <div css={textStyle}>
          <div>
            <span css={labelStyle}>{t("label:common.numberOfChildren")}</span>
            <span css={ageStyle}>
              {t("unit:rangeOfAges", {
                min: 0,
                max: MAX_AGE_OF_CHILDREN,
              })}
            </span>
          </div>
        </div>
        <NumberInputSpinner
          name={fieldName}
          min={0}
          max={max || MAX_CHILDREN}
          onUpdate={onUpdate}
        />
      </div>
      <div css={childrenAgeBlockStyle}>
        <GuestChildrenAgeBlock
          namespace={namespace}
          groupName={groupName}
          maxAgeOfChildren={MAX_AGE_OF_CHILDREN}
          borderColorStyleKey="secondary"
        />
      </div>
    </div>
  );
};

const listInnerStyle = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${space.atom1_5x} ${space.atom0_5x} ${space.atom1_5x} ${space.atom};
  font-weight: ${fontWeight.bold};
`;
const childSubListInnerStyle = css`
  font-weight: ${fontWeight.regular};
  font-size: ${fontSize.caption};
`;
const textStyle = css`
  font-size: ${fontSize.body};
  line-height: ${lineHeight.body2};
  padding-right: ${space.atom2x};
`;
const labelStyle = css`
  font-weight: ${fontWeight.bold};
`;
const ageStyle = css`
  padding-left: ${space.atom1_5x};
  color: ${textColor.secondaryDarkColor};
`;
const childrenAgeBlockStyle = css`
  padding-top: ${space.atom2x};
`;
